import { createActions, createReducer } from "reduxsauce";
import Immutable from "seamless-immutable";

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  profileAuthenticationCheckSuccess: ["payload"],

  profileRequest: ["resolve"],
  profileSuccess: ["payload"],
  profileFailure: ["error"],

  publicProfileRequest: ["data", "resolve"],
  publicProfileSuccess: ["payload"],
  publicProfileFailure: ["error"],

  getProfileLinksRequest: ["data"],
  getProfileLinksSuccess: ["payload"],
  getProfileLinksFailure: ["error"],

  updateProfileLinksRequest: ["data", "resolve"],
  updateProfileLinksSuccess: ["payload"],
  updateProfileLinksFailure: ["error"],

  profileUpdateRequest: ["data", "resolve"],
  profileUpdateSuccess: ["payload"],
  profileUpdateFailure: ["error"],

  createProfileRequest: ["data"],
  createProfileSuccess: ["payload"],
  createProfileFailure: ["error"],

  profileModalId: ["payload"],

  giveProfileReviewRequest: ["data"],
  giveProfileReviewSuccess: ["payload"],
  giveProfileReviewFailure: ["error"],

  updateAvatarRequest: ["data"],
  updateAvatarSuccess: ["payload"],
  updateAvatarFailure: ["error"],

  subscribeUserRequest: ["data"],
  subscribeUserSuccess: ["payload"],
  subscribeUserFailure: ["error"],
});

export const ProfileTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  loading: false,
  error: null,
  profile: null,
  publicProfile: {
    id: null,
    first_name: null,
    review_score: 0,
  },
  publicProfileLinks: [],
  profileModalId: null,
});

/* ------------- Reducers ------------- */

export const profileAuthenticationCheckSuccess = (state, { payload }) =>
  state.merge({
    fetching: false,
    profile: payload.profile,
    location: payload.location_details,
  });

export const profileRequest = (state, action) =>
  state.merge({ fetching: true });

export const profileSuccess = (state, { payload }) =>
  state.merge({
    fetching: false,
    error: null,
    profile: payload.profile,
  });

export const profileFailure = (state, data) =>
  state.merge({ fetching: false, error: data, profile: null });

export const publicProfileRequest = (state) => state.merge({ fetching: true });

export const publicProfileSuccess = (state, { payload }) =>
  state.merge({
    fetching: false,
    error: null,
    publicProfile: payload.profile,
    publicProfileLinks: payload.links,
  });

export const publicProfileFailure = (state, { error }) =>
  state.merge({ fetching: false, error: error });

export const getProfileLinksRequest = (state) =>
  state.merge({ fetching: true });

export const getProfileLinksSuccess = (state, { payload }) => {
  return state.merge({
    fetching: false,
    error: null,
    publicProfileLinks: payload,
  });
};

export const getProfileLinksFailure = (state, { error }) =>
  state.merge({ fetching: false, error: error });

export const updateProfileLinksRequest = (state) =>
  state.merge({ fetching: true });

export const updateProfileLinksSuccess = (state, { payload }) => {
  return state.merge({
    fetching: false,
    error: null,
    publicProfileLinks: payload,
  });
};

export const updateProfileLinksFailure = (state, { error }) =>
  state.merge({ fetching: false, error: error });

export const profileUpdateRequest = (state, data) =>
  state.merge({
    fetching: true,
    error: null,
  });
export const profileUpdateSuccess = (state, { payload }) =>
  state.merge({
    fetching: false,
    error: null,
    profile: payload.profile,
  });

export const profileUpdateFailure = (state, data) =>
  state.merge({
    fetching: false,
    error: data.error,
  });

export const createProfileRequest = (state) => state.merge({ fetching: true });

export const createProfileSuccess = (state) =>
  state.merge({ fetching: false, error: null });

export const createProfileFailure = (state, data) =>
  state.merge({ fetching: false, error: data });

export const profileModalId = (state, data) =>
  state.merge({ profileModalId: data.payload });

export const updateAvatarRequest = (state, action) =>
  state.merge({ fetching: true, error: null });

export const updateAvatarSuccess = (state, action) =>
  state.merge({ fetching: false, profile: action.payload });

export const updateAvatarFailure = (state, action) =>
  state.merge({ fetching: false, error: action.error });

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.PROFILE_AUTHENTICATION_CHECK_SUCCESS]: profileAuthenticationCheckSuccess,
  [Types.PROFILE_REQUEST]: profileRequest,
  [Types.PROFILE_SUCCESS]: profileSuccess,
  [Types.PROFILE_FAILURE]: profileFailure,

  [Types.PUBLIC_PROFILE_REQUEST]: publicProfileRequest,
  [Types.PUBLIC_PROFILE_SUCCESS]: publicProfileSuccess,
  [Types.PUBLIC_PROFILE_FAILURE]: publicProfileFailure,

  [Types.PROFILE_UPDATE_REQUEST]: profileUpdateRequest,
  [Types.PROFILE_UPDATE_SUCCESS]: profileUpdateSuccess,
  [Types.PROFILE_UPDATE_FAILURE]: profileUpdateFailure,

  [Types.CREATE_PROFILE_REQUEST]: createProfileRequest,
  [Types.CREATE_PROFILE_SUCCESS]: createProfileSuccess,
  [Types.CREATE_PROFILE_FAILURE]: createProfileFailure,

  [Types.PROFILE_MODAL_ID]: profileModalId,

  [Types.UPDATE_AVATAR_REQUEST]: updateAvatarRequest,
  [Types.UPDATE_AVATAR_SUCCESS]: updateAvatarSuccess,
  [Types.UPDATE_AVATAR_FAILURE]: updateAvatarFailure,

  [Types.GET_PROFILE_LINKS_REQUEST]: getProfileLinksRequest,
  [Types.GET_PROFILE_LINKS_SUCCESS]: getProfileLinksSuccess,
  [Types.GET_PROFILE_LINKS_FAILURE]: getProfileLinksFailure,

  [Types.UPDATE_PROFILE_LINKS_REQUEST]: updateProfileLinksRequest,
  [Types.UPDATE_PROFILE_LINKS_SUCCESS]: updateProfileLinksSuccess,
  [Types.UPDATE_PROFILE_LINKS_FAILURE]: updateProfileLinksFailure,
});

/* ------------- Selectors ------------- */

export const ProfileSelectors = {
  getProfile: (state) => state.profile.profile,
  getPublicProfile: (state) => state.profile.publicProfile,
  getPersonalFixList: (state) => state.profile.personalFixList,
  getFilteredPersonalFixList: (state) => state.profile.filteredPersonalFixList,
  getSelectedPersonalFix: (state) => state.profile.selectedPersonalFixModal,
  getProfileModalId: (state) => state.profile.profileModalId,
  getError: (state) => state.profile.error,
  getLocation: (state) => state.profile.location,
  getFetching: (state) => state.profile.fetching,
  getTotalPersonalFixes: (state) => state.profile.totalPersonalFixes,
  getFavouriteJobs: (state) => state.profile.favouritedJobs,
  getRequestJobs: (state) => state.profile.requestedJobs,
  getRequestDetails: (state) => state.profile.requestDetails,
  getProfileLinks: (state) => state.profile.publicProfileLinks,
};
